import React, { useState } from "react";
import { QrReader } from "react-qr-reader";
import Drawer from "react-modern-drawer";
import * as Assets from "../../utils/svg_assets";

const ReaderScan = (props) => {
  const { showScan, setShowScan, setValue } = props;
  const [refCamera, setRefCamera] = useState("environment");

  const handleRefCamera = () => {
    setRefCamera(refCamera === "environment" ? "user" : "environment");
  };

  const HeaderScan = (props) => {
    const innerStyle = {
      borderBottom: "1px solid #ebebeb",
    };

    return (
      <div
        className="scan-navigation"
        style={props.setBorder ? innerStyle : { boxShadow: "none" }}
      >
        <div
          className="left-navigation"
          onClick={() => {
            setShowScan(false);
          }}
        >
          {props.showLeftIcon && (
            <img
              src={props.iconLeft}
              className="icon-left-scan"
              alt="arrow-back"
            />
          )}
        </div>
        <div className="title-page">{props.titlePage}</div>
        <div className="right-navigation" onClick={handleRefCamera}>
          {props.showRightIcon && (
            <img
              src={props.iconRight}
              className="icon-right-scan"
              alt="filter"
            />
          )}
        </div>
      </div>
    );
  };

  const ReaderScan = () => {
    const innerStyle = {
      textAlign: "center",
      margin: "auto",
      maxWidth: 400,
      width: "75%",
    };

    return (
      <div style={innerStyle}>
        <QrReader
          delay={500}
          onResult={(result, error) => {
            if (result) {
              setValue(result?.text);
            }
            if (error) {
              //console.info(error);
            }
          }}
          style={{ width: "100%" }}
          constraints={{ facingMode: refCamera }}
        />
      </div>
    );
  };

  return (
    <Drawer
      open={showScan}
      onClose={() => setShowScan(false)}
      direction="right"
      size={400}
      enableOverlay={false}
      overlayColor={"#ffffff"}
    >
      <HeaderScan
        titlePage="Scan QR Code"
        setBorder={true}
        showRightIcon={true}
        showLeftIcon={true}
        iconLeft={Assets.iconBack}
        iconRight={
          refCamera === "environment" ? Assets.iconEye : Assets.iconEyeActive
        }
        onRightNavClicked={handleRefCamera}
      />
      {showScan && <ReaderScan />}
    </Drawer>
  );
};

export default ReaderScan;
